<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('pqr.client_location_info') }}</p>
    <hr />
    <select-address
      ref="selectAddress"
      :requiredFields="requireAddress"
      :showZipCode="false"
      @showHideLoading="showHideLoading"
      @onChange="handleChangeSelected"
    />
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        address: null,
        country: null,
        city: null,
        state: null,
      },
      requireAddress: true,
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  methods: {
    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!response) return false;

        if (!this.requireAddress) {
          this.$emit('on-validated', response, { ...this.model });

          return true;
        }

        return new Promise((resolve) => {
          this.$refs.selectAddress.$emit('validateAddress', (isValid) => {
            if (isValid) {
              this.$emit('on-validated', response, { ...this.model });
            }

            resolve(isValid);
          });
        });
      });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },
};
</script>
